import { render, staticRenderFns } from "./ModalAvaliacao.vue?vue&type=template&id=5f9d6272"
import script from "./ModalAvaliacao.vue?vue&type=script&lang=js"
export * from "./ModalAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./ModalAvaliacao.vue?vue&type=style&index=0&id=5f9d6272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports